import { fmtInt } from '../../lib/format'
import type { LadderRowView } from '../../lib/deskToday'

const num = (n: number | null) => (n === null ? '—' : fmtInt(n))

/** The reader ladder as six cards: people on each rung, a thin bar against the largest
 *  rung, and how many moved up or down since the previous window. Arrows carry text. */
export function LadderBars({ rows, period }: { rows: LadderRowView[]; period: string }) {
  const summary = rows.map((r) => `${r.label} ${num(r.people)}`).join(', ')
  return (
    <ul role="list" aria-label={`Reader ladder, ${period}: ${summary}`} className="grid gap-2.5 grid-cols-2 md:grid-cols-3 xl:grid-cols-6">
      {rows.map((r) => (
        <li key={r.label} className={`min-w-0 border p-3 ${r.isKey ? 'border-amber-glow bg-ink-700' : 'border-ink-500 bg-ink-800'}`}>
          <div className="font-semibold text-paper">{r.label}</div>
          <div className="min-h-[34px] text-[12px] text-paper-faint">{r.definition}</div>
          <div className="my-1.5 font-mono text-[26px] font-semibold leading-none text-paper" style={{ fontVariantNumeric: 'tabular-nums' }}>{num(r.people)}</div>
          <div className="h-1.5 bg-ink-600" aria-hidden="true"><div className="h-1.5 bg-amber-glow" style={{ width: `${r.widthPct}%` }} /></div>
          <div className="mt-2 font-mono text-[12px] text-paper-dim">
            {r.up === null && r.down === null ? <span>—</span> : (
              <>
                <span className="text-radar-cyan">▲ {num(r.up)} up</span>
                {' · '}
                <span className="text-amber-glow">▼ {num(r.down)} down</span>
              </>
            )}
          </div>
        </li>
      ))}
    </ul>
  )
}
